export default __webpack_public_path__ + "static/media/applAssis.74b80e8c.jpeg";